import { Logger } from '../logger'
import { axiosPublic } from './api'

/**
 * GET /v1/public/billing/catalog — the plan catalog, straight from the database (tier,
 * feature_module, entitlement). Public: the sign-up plan picker needs it before login.
 * Resolves to `{ tiers: [{ id, name, rank, priceCents, tagline, highlights, perks, onSale,
 * recommended, modules }], modules: [{ id, name }] }`.
 */
export const getBillingCatalog = async () => {
  try {
    const response = await axiosPublic.get('/v1/public/billing/catalog')
    return response?.data
  } catch (error) {
    Logger.error({ message: error, payload: { file: 'catalogApi', method: 'getBillingCatalog' } })
    throw error
  }
}
